import React from 'react'

import { IconProps } from '../../../common/types'

const ThreeDotHorizontal: React.FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.33335 8.46842H3.34002M8.00002 8.46842H8.00669M12.6667 8.46842H12.6734M4.00002 8.46842C4.00002 8.83661 3.70154 9.13509 3.33335 9.13509C2.96516 9.13509 2.66669 8.83661 2.66669 8.46842C2.66669 8.10023 2.96516 7.80176 3.33335 7.80176C3.70154 7.80176 4.00002 8.10023 4.00002 8.46842ZM8.66669 8.46842C8.66669 8.83661 8.36821 9.13509 8.00002 9.13509C7.63183 9.13509 7.33335 8.83661 7.33335 8.46842C7.33335 8.10023 7.63183 7.80176 8.00002 7.80176C8.36821 7.80176 8.66669 8.10023 8.66669 8.46842ZM13.3334 8.46842C13.3334 8.83661 13.0349 9.13509 12.6667 9.13509C12.2985 9.13509 12 8.83661 12 8.46842C12 8.10023 12.2985 7.80176 12.6667 7.80176C13.0349 7.80176 13.3334 8.10023 13.3334 8.46842Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ThreeDotHorizontal
